import React from "react";
import { Button } from "reactstrap";
import TableContainerWarehouseRx from "../../../../../components/Common/TableContainerWarehouseRx";
import { withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";

const BonusTable = ({
  tableData,
  bonusColumns,
  assignedBonuses,
  openDeleteModal,
  openDisableModal,
  openEditModal, 
  handleDisableBonus,
  isDeleting,
  isDisabling,
  isUpdating, 
  t,
}) => {
  // Ajout de la colonne Actions avec Edit, Delete et Disable
  const columnsWithActions = [
    ...bonusColumns,
    {
      header: "Actions",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }) => {
        const assigned = row.original;

        const stopEvent = (e) => e.stopPropagation();

        const handleEdit = (e) => {
          e.preventDefault();
          e.stopPropagation();
          openEditModal(assigned);
        };

        const handleDelete = (e) => {
          e.preventDefault();
          e.stopPropagation();
          openDeleteModal(assigned);
        };

        const handleDisable = (e) => {
          e.preventDefault();
          e.stopPropagation();
          openDisableModal(assigned);
        };

        return (
          <div className="d-flex gap-1" onClick={stopEvent} onMouseDown={stopEvent}>
            {/* Bouton Edit */}
            <Button
              color=""
              size="sm"
              onClick={handleEdit}
              onMouseDown={stopEvent}
              title={t("edit")}
              className="btn-sm px-2 py-1"
              disabled={isUpdating}
            >
              {isUpdating ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <svg xmlns="" width="18" height="18" fill="green" viewBox="0 0 24 24">
                  <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" />
                </svg>
              )}
            </Button>

            {/* Bouton Disable */}
            <Button
              color=""
              size="sm"
              onClick={handleDisable}
              onMouseDown={stopEvent}
              title={t("disable")}
              className="btn-sm px-2 py-1"
              disabled={isDisabling}
            >
              {isDisabling ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-ban" style={{ color: "#ffc107" }}></i>
              )}
            </Button>

            {/* Bouton Delete */}
            <Button
              color=""
              size="sm"
              onClick={handleDelete}
              onMouseDown={stopEvent}
              title={t("delete")}
              className="btn-sm px-2 py-1"
              disabled={isDeleting}
              style={{ zIndex: 1000 }}
            >
              {isDeleting ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-trash" style={{ color: "#dc3545" }}></i>
              )}
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="mt-3">
      {assignedBonuses.length > 0 ? (
        <div className="card border-0 row p-2">
          <div className="card-header bg-white border-0 pb-0">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">
                <i className="fa fa-gift me-2 text-success"></i>
                {t("Assigned_bonuses")} ({assignedBonuses.length})
              </h6>
              <div className="text-muted small">
                {t("total")} :{" "}
                <span className="fw-bold text-success">
                  {assignedBonuses
                    .reduce((total, ab) => total + (ab.amount || 0), 0)
                    .toLocaleString()}{" "}
                  {t("XOF")}
                </span>
              </div>
            </div>
          </div>
          <div className="card-body">
            <TableContainerWarehouseRx
              columns={columnsWithActions}
              data={tableData}
              customPageSize={10}
              tableClass="table-borderless table-hover"
              theadClass="table-light"
              trClass=""
              tdClass=""
              divClass="table-responsive"
              tablePage={1}
              tableTotal={assignedBonuses.length}
              tableTotalPage={1}
              onNextPage={() => {}}
              t={t}
            />
          </div>
        </div>
      ) : (
        <div className="card border-0 row p-2">
          <div className="card-body text-center p-5">
            <div className="text-muted">
              <i className="fa fa-gift fa-3x mb-3 text-muted"></i>
              <h5 className="text-muted">{t("no_bonuses_assigned")}</h5>
              <p className="text-muted">{t("select_bonus_to_assign")}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(withTranslation()(BonusTable));